<template>
  <div class="text-center text-info my-2">
    <BSpinner class="align-middle mr-2"></BSpinner>
    <strong>Loading...</strong>
  </div>
</template>

<script lang="ts">
import { BSpinner } from "bootstrap-vue-next";
import { defineComponent } from "vue";

export default defineComponent({
  name: "GridLoading",
  components: { BSpinner }
});
</script>
